import React, { PropsWithChildren, useContext } from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';

import { PDFDataContext } from '../../context';
import HeaderWrapper from '../../Wrappers/HeaderWrapper';
import PageWrapper from '../../Wrappers/PageWrapper';
import Logo from '../shared/Logo';
import Footer from './Footer';
import Header from './Header';
import s from './index.module.css';

export function TemplateHeader() {
  const { title, logo, preparedFor, travelDates, companyName, email, phone } = useContext(PDFDataContext);

  return (
    <HeaderWrapper className={s.info}>
      <div className={s.logo}>
        <div className={s.logoInner}>
          <Logo logo={logo} companyName={companyName} />
        </div>
      </div>

      <div className={s.left}>
        <Text className={s.text} accent>
          {preparedFor && `${i18n.t('proposal_content.prepared_for')} ${preparedFor}`}
        </Text>

        <Text className={s.text} accent>
          {title}
        </Text>

        <Text className={s.text} accent>
          {travelDates}
        </Text>
      </div>
      <div className={s.right}>
        <Text className={s.text} accent>
          {companyName}
        </Text>

        <Text className={s.text} accent>
          {email}
        </Text>

        <Text className={s.text} accent>
          {phone}
        </Text>
      </div>
    </HeaderWrapper>
  );
}

function TemplatePage({ children, className }: PropsWithChildren<{ className?: string }>) {
  const PDFData = useContext(PDFDataContext);

  return (
    <PageWrapper>
      <Header {...PDFData} />

      <div className={cx(s.contentWrapper, className)}>{children}</div>

      <Footer />
    </PageWrapper>
  );
}

TemplatePage.Header = Header;
TemplatePage.Footer = Footer;
export default TemplatePage;
